import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'
// helpers
import authService from 'authService'
import inRange from 'lodash/inRange'
import toLower from 'lodash/toLower'
import get from 'lodash/get'

// dr-utils
const { REACT_APP_BASE_URL: API_URL, REACT_APP_NAME: APP_NAME } = process.env

type dataType = {
  query: string
  variables?: any
}

export type requestType = {
  url?: string
  headers?: any
  data: dataType
  method?: 'post' | 'get' | 'options'
}

const onError = (e: any) => {
  if (
    inRange(get(e, 'response.status', 0), 400, 411) &&
    toLower(get(e, 'response.data.message', '')).includes('token')
  ) {
    window.localStorage.removeItem(APP_NAME)
    return document.location.reload()
  }
  return e
}

const urlDefault = `${API_URL}/`

const axiosRequest = ({
  url = urlDefault,
  headers: customHeaders = {},

  ...config
}: AxiosRequestConfig): AxiosPromise => {
  const { clientId, token } = authService.state

  const headers = {
    'x-access-token': token,
    'client-id': clientId,
    ...customHeaders
  }

  return axios({
    baseURL: API_URL,
    url,
    headers,
    ...config
  }).catch(onError) as AxiosPromise
}

export default axiosRequest
